export const core = {
  [`blur`]: {},
  [`borders`]: {},
  [`breakpoints`]: {},
  [`colors`]: {
    [`blue-spark`]: {
      [`100`]: '#e8f2ff',
      [`200`]: '#d1e4ff',
      [`300`]: '#a2c9ff',
      [`400`]: '#73adff',
      [`500`]: '#4090ff',
      [`600`]: '#076eff',
      [`700`]: '#0056d0',
      [`800`]: '#00419d',
      [`900`]: '#002d6d',
      [`1000`]: '#001a40',
    },
    [`sea-sight`]: {
      [`100`]: '#d9f6ff',
      [`200`]: '#b1ecff',
      [`300`]: '#55d5ff',
      [`400`]: '#00b8f4',
      [`500`]: '#009ccf',
      [`600`]: '#0080aa',
      [`700`]: '#006687',
      [`800`]: '#004d66',
      [`900`]: '#003546',
      [`1000`]: '#001f29',
    },
    [`macquarie`]: {
      [`100`]: '#d9f6f7',
      [`200`]: '#b2edf0',
      [`300`]: '#58d8de',
      [`400`]: '#00bec5',
      [`500`]: '#00a1a7',
      [`600`]: '#00848a',
      [`700`]: '#00696d',
      [`800`]: '#004f52',
      [`900`]: '#003739',
      [`1000`]: '#002021',
    },
    [`generic-viridian`]: {
      [`100`]: '#d8f7f0',
      [`200`]: '#afefe1',
      [`300`]: '#51dcbd',
      [`400`]: '#00c296',
      [`500`]: '#00a47f',
      [`600`]: '#008769',
      [`700`]: '#006b53',
      [`800`]: '#00513f',
      [`900`]: '#00382b',
      [`1000`]: '#002019',
    },
    [`green-bell-pepper`]: {
      [`100`]: '#e1f7d8',
      [`200`]: '#c1efb0',
      [`300`]: '#7cdd56',
      [`400`]: '#37c500',
      [`500`]: '#2fa700',
      [`600`]: '#268900',
      [`700`]: '#1e6d00',
      [`800`]: '#175200',
      [`900`]: '#103900',
      [`1000`]: '#092100',
    },
    [`sizzling-sunrise`]: {
      [`100`]: '#fff2a5',
      [`200`]: '#ffe336',
      [`300`]: '#eac300',
      [`400`]: '#d0a600',
      [`500`]: '#bd8a00',
      [`600`]: '#9d6e00',
      [`700`]: '#7d5800',
      [`800`]: '#624000',
      [`900`]: '#432c00',
      [`1000`]: '#271900',
    },
    [`golden-stone`]: {
      [`100`]: '#fff0cb',
      [`200`]: '#ffdf93',
      [`300`]: '#ffbb16',
      [`400`]: '#e99b00',
      [`500`]: '#c77100',
      [`600`]: '#a85a00',
      [`700`]: '#8a4900',
      [`800`]: '#663600',
      [`900`]: '#472600',
      [`1000`]: '#291500',
    },
    [`lucky-orange`]: {
      [`100`]: '#ffeedf',
      [`200`]: '#ffdcbe',
      [`300`]: '#ffb77a',
      [`400`]: '#ff8e2c',
      [`500`]: '#e96c00',
      [`600`]: '#c25400',
      [`700`]: '#9e3f00',
      [`800`]: '#7c2e00',
      [`900`]: '#571d00',
      [`1000`]: '#331100',
    },
    [`electric-crimson`]: {
      [`100`]: '#ffecf1',
      [`200`]: '#ffd9e3',
      [`300`]: '#ffb1c5',
      [`400`]: '#ff85a4',
      [`500`]: '#ff4e7b',
      [`600`]: '#ed003d',
      [`700`]: '#bf0031',
      [`800`]: '#920025',
      [`900`]: '#67001a',
      [`1000`]: '#400010',
    },
    [`snappy-violet`]: {
      [`100`]: '#ffebf8',
      [`200`]: '#ffd7f1',
      [`300`]: '#ffade2',
      [`400`]: '#ff7ed1',
      [`500`]: '#ff3dba',
      [`600`]: '#e30093',
      [`700`]: '#b60076',
      [`800`]: '#8b005a',
      [`900`]: '#620040',
      [`1000`]: '#3d0027',
    },
    [`psychedelic-purple`]: {
      [`100`]: '#fcebff',
      [`200`]: '#f9d8ff',
      [`300`]: '#f3aeff',
      [`400`]: '#ec81ff',
      [`500`]: '#e447ff',
      [`600`]: '#c900ec',
      [`700`]: '#a100bd',
      [`800`]: '#7b0090',
      [`900`]: '#570066',
      [`1000`]: '#35003f',
    },
    [`electric-indigo`]: {
      [`100`]: '#f5eeff',
      [`200`]: '#eaddff',
      [`300`]: '#d5baff',
      [`400`]: '#c098ff',
      [`500`]: '#aa74ff',
      [`600`]: '#914cff',
      [`700`]: '#7016ff',
      [`800`]: '#5000cf',
      [`900`]: '#390093',
      [`1000`]: '#23005b',
    },
    [`obsidian`]: {
      [`100`]: '#f4f5f6',
      [`200`]: '#e6e8ea',
      [`300`]: '#c6ced2',
      [`400`]: '#a0adb4',
      [`500`]: '#83939c',
      [`600`]: '#667a85',
      [`700`]: '#4e616b',
      [`800`]: '#3a4951',
      [`900`]: '#283237',
      [`1000`]: '#171c1f',
    },
    [`blue-sari`]: {
      [`100`]: '#f4f4f6',
      [`200`]: '#e0e3e7',
      [`300`]: '#c2c7cf',
      [`400`]: '#a5abb8',
      [`500`]: '#8891a2',
      [`600`]: '#6d778c',
      [`700`]: '#545f74',
      [`800`]: '#3f4757',
      [`900`]: '#2b313b',
      [`1000`]: '#181c22',
    },
    [`deep-sea`]: {
      [`100`]: '#f8f9ff',
      [`200`]: '#e2e2e8',
      [`300`]: '#c6c5d2',
      [`400`]: '#aba9bc',
      [`500`]: '#908ea6',
      [`600`]: '#767492',
      [`700`]: '#5e5b7d',
      [`800`]: '#46445e',
      [`900`]: '#302e40',
      [`1000`]: '#1b1a25',
    },
    [`grey`]: {
      [`100`]: '#f1f1f1',
      [`200`]: '#e2e2e2',
      [`300`]: '#c6c6c6',
      [`400`]: '#ababab',
      [`500`]: '#919191',
      [`600`]: '#777777',
      [`700`]: '#5e5e5e',
      [`800`]: '#474747',
      [`900`]: '#303030',
      [`1000`]: '#1b1b1b',
    },
    [`bonsai-trunk`]: {
      [`100`]: '#f1f1f0',
      [`200`]: '#e2e2e1',
      [`300`]: '#c7c7c3',
      [`400`]: '#ababa6',
      [`500`]: '#91918a',
      [`600`]: '#78786f',
      [`700`]: '#5f5f57',
      [`800`]: '#474741',
      [`900`]: '#31312c',
      [`1000`]: '#1c1c19',
    },
    [`trail-print`]: {
      [`100`]: '#f1f1f0',
      [`200`]: '#e3e2e2',
      [`300`]: '#c8c6c5',
      [`400`]: '#adaba9',
      [`500`]: '#94908e',
      [`600`]: '#7b7673',
      [`700`]: '#625d5b',
      [`800`]: '#494644',
      [`900`]: '#32302e',
      [`1000`]: '#1d1b1a',
    },
    [`white`]: {
      [`0`]: '#ffffff00',
      [`3`]: '#ffffff08',
      [`5`]: '#ffffff0d',
      [`10`]: '#ffffff1a',
      [`20`]: '#ffffff33',
      [`30`]: '#ffffff4d',
      [`40`]: '#ffffff66',
      [`50`]: '#ffffff80',
      [`60`]: '#ffffff99',
      [`70`]: '#ffffffb3',
      [`80`]: '#ffffffcc',
      [`90`]: '#ffffffe6',
      [`100`]: '#ffffff',
    },
    [`black`]: {
      [`3`]: '#00000008',
      [`5`]: '#0000000d',
      [`10`]: '#0000001a',
      [`20`]: '#00000033',
      [`30`]: '#0000004d',
      [`40`]: '#00000066',
      [`50`]: '#00000080',
      [`60`]: '#00000099',
      [`70`]: '#000000b3',
      [`80`]: '#000000cc',
      [`90`]: '#000000e6',
      [`100`]: '#000000',
    },
    [`brand`]: {
      [`primary`]: {
        [`100`]: '#e8f2ff',
        [`200`]: '#d1e4ff',
        [`300`]: '#a2c9ff',
        [`400`]: '#73adff',
        [`500`]: '#4090ff',
        [`600`]: '#076eff',
        [`700`]: '#0056d0',
        [`800`]: '#00419d',
        [`900`]: '#002d6d',
        [`1000`]: '#001a40',
      },
      [`neutral`]: {
        [`100`]: '#f4f5f6',
        [`200`]: '#e6e8ea',
        [`300`]: '#c6ced2',
        [`400`]: '#a0adb4',
        [`500`]: '#83939c',
        [`600`]: '#667a85',
        [`700`]: '#4e616b',
        [`800`]: '#3a4951',
        [`900`]: '#283237',
        [`1000`]: '#171c1f',
      },
      [`success`]: {
        [`100`]: '#e1f7d8',
        [`200`]: '#c1efb0',
        [`300`]: '#7cdd56',
        [`400`]: '#37c500',
        [`500`]: '#2fa700',
        [`600`]: '#268900',
        [`700`]: '#1e6d00',
        [`800`]: '#175200',
        [`900`]: '#103900',
        [`1000`]: '#092100',
      },
      [`warning`]: {
        [`100`]: '#fff0cb',
        [`200`]: '#ffdf93',
        [`300`]: '#ffbb16',
        [`400`]: '#ff8e2c',
        [`500`]: '#e96c00',
        [`600`]: '#c25400',
        [`700`]: '#9e3f00',
        [`800`]: '#7c2e00',
        [`900`]: '#571d00',
        [`1000`]: '#331100',
      },
      [`danger`]: {
        [`100`]: '#ffecf1',
        [`200`]: '#ffd9e3',
        [`300`]: '#ffb1c5',
        [`400`]: '#ff85a4',
        [`500`]: '#ff4e7b',
        [`600`]: '#ed003d',
        [`700`]: '#bf0031',
        [`800`]: '#920025',
        [`900`]: '#67001a',
        [`1000`]: '#400010',
      },
    },
  },
  [`direction`]: 'ltr',
  [`fonts`]: {},
  [`fontSizes`]: {},
  [`fontWeights`]: {},
  [`letterSpacings`]: {},
  [`lineHeights`]: {},
  [`radii`]: {
    [`radius-0`]: '0rem',
    [`radius-050`]: '0.25rem',
    [`radius-100`]: '0.5rem',
    [`radius-150`]: '0.75rem',
    [`radius-200`]: '1rem',
    [`radius-300`]: '1.5rem',
    [`radius-400`]: '2rem',
    [`radius-500`]: '2.5rem',
    [`radius-600`]: '3rem',
    [`radius-800`]: '4rem',
    [`radius-1000`]: '5rem',
    [`radius-rounded`]: '62.5rem',
    [`tabs`]: {
      [`lg`]: '62.5rem',
      [`md`]: '62.5rem',
      [`sm`]: '62.5rem',
      [`xs`]: '62.5rem',
    },
    [`buttons`]: {
      [`lg`]: '62.5rem',
      [`md`]: '62.5rem',
      [`sm`]: '62.5rem',
      [`xs`]: '62.5rem',
    },
    [`tags`]: {
      [`lg`]: '0.5rem',
      [`md`]: '0.5rem',
      [`sm`]: '0.25rem',
      [`xs`]: '0.25rem',
      [`xxs`]: '0.25rem',
    },
    [`filters`]: {
      [`radius`]: '0.75rem',
    },
    [`action-menu`]: {
      [`item`]: '1rem',
    },
    [`navigation`]: {
      [`item`]: '0.5rem',
      [`item-collapsed`]: '62.5rem',
    },
    [`tables`]: {
      [`radius`]: '0.5rem',
    },
    [`dialog`]: '1rem',
    [`dropdown`]: {
      [`radius`]: '1rem',
    },
  },
  [`shadows`]: {
    [`shadow-xs`]: {
      [`x`]: '0rem',
      [`y`]: '0.0625rem',
      [`blur`]: '0.125rem',
      [`spread`]: '0rem',
    },
    [`shadow-s-1`]: {
      [`x`]: '0rem',
      [`y`]: '0.0625rem',
      [`blur`]: '0.125rem',
      [`spread`]: '0rem',
    },
    [`shadow-s-2`]: {
      [`x`]: '0rem',
      [`y`]: '0.0625rem',
      [`blur`]: '0.1875rem',
      [`spread`]: '0rem',
    },
    [`shadow-m-1`]: {
      [`x`]: '0rem',
      [`y`]: '0.25rem',
      [`blur`]: '0.375rem',
      [`spread`]: '-0.0625rem',
    },
    [`shadow-m-2`]: {
      [`x`]: '0rem',
      [`y`]: '0.125rem',
      [`blur`]: '0.25rem',
      [`spread`]: '-0.0625rem',
    },
    [`shadow-l-1`]: {
      [`x`]: '0rem',
      [`y`]: '0.5rem',
      [`blur`]: '0.75rem',
      [`spread`]: '-0.125rem',
    },
    [`shadow-l-2`]: {
      [`x`]: '0rem',
      [`y`]: '0.125rem',
      [`blur`]: '0.375rem',
      [`spread`]: '-0.125rem',
    },
    [`shadow-xl-1`]: {
      [`x`]: '0rem',
      [`y`]: '1rem',
      [`blur`]: '1.5rem',
      [`spread`]: '-0.25rem',
    },
    [`shadow-xl-2`]: {
      [`x`]: '0rem',
      [`y`]: '0.25rem',
      [`blur`]: '0.5rem',
      [`spread`]: '-0.125rem',
    },
    [`shadow-xxl-1`]: {
      [`x`]: '0rem',
      [`y`]: '1.5rem',
      [`blur`]: '2.5rem',
      [`spread`]: '-0.25rem',
    },
    [`shadow-xxl-2`]: {
      [`x`]: '0rem',
      [`y`]: '0.375rem',
      [`blur`]: '1rem',
      [`spread`]: '-0.125rem',
    },
    [`shadow-left-side-table`]: {
      [`x`]: '-0.1875rem',
      [`y`]: '0rem',
      [`blur`]: '1rem',
      [`spread`]: '0rem',
    },
    [`shadow-right-side-table`]: {
      [`x`]: '1rem',
      [`y`]: '1rem',
      [`blur`]: '1.5rem',
      [`spread`]: '-0.25rem',
    },
    [`shadow-negative-y`]: {
      [`shadow-color`]: '#00000008',
      [`x`]: '0rem',
      [`y`]: '0rem',
      [`blur`]: '0.875rem',
      [`spread`]: '0rem',
    },
  },
  [`sizes`]: {},
  [`space`]: {
    [`space-0`]: '0rem',
    [`space-050`]: '0.25rem',
    [`space-100`]: '0.5rem',
    [`space-150`]: '0.75rem',
    [`space-200`]: '1rem',
    [`space-300`]: '1.5rem',
    [`space-400`]: '2rem',
    [`space-500`]: '2.5rem',
    [`space-600`]: '3rem',
    [`space-800`]: '4rem',
    [`space-1000`]: '5rem',
    [`space-700`]: '3.5rem',
    [`space-900`]: '4.5rem',
    [`space-1100`]: '5.5rem',
    [`space-1200`]: '6rem',
    [`space-250`]: '1.25rem',
  },
  [`transition`]: {},
  [`zIndices`]: {},
};

export type CoreTheme = typeof core;

export const semantic = {
  [`colors`]: {
    [`text`]: {
      [`primary`]: 'white.100',
      [`secondary`]: 'brand.neutral.400',
      [`tertiary`]: 'brand.neutral.600',
      [`brand-bold`]: 'brand.primary.200',
      [`state`]: {
        [`success-bold`]: 'brand.success.100',
        [`success-subtle`]: 'brand.success.700',
        [`warning-bold`]: 'brand.warning.100',
        [`warning-subtle`]: 'brand.warning.700',
        [`danger-bold`]: 'brand.danger.100',
        [`danger-subtle`]: 'brand.danger.700',
        [`disabled`]: 'brand.neutral.700',
        [`warning-bold-hover`]: 'brand.warning.200',
      },
      [`brand-subtle`]: 'brand.primary.900',
      [`brand-medium`]: 'brand.primary.400',
      [`primary-inverse`]: 'black.100',
      [`secondary-inverse`]: 'brand.neutral.700',
      [`tertiary-inverse`]: 'brand.neutral.500',
      [`on-dark-background`]: 'white.100',
      [`on-light-background`]: 'black.100',
    },
    [`background`]: {
      [`primary`]: 'black.100',
      [`secondary`]: 'brand.neutral.1000',
      [`tertiary`]: 'brand.neutral.800',
      [`state`]: {
        [`success-subtle`]: 'brand.success.500',
        [`success-bold`]: 'brand.success.200',
        [`warning-subtle`]: 'brand.warning.500',
        [`warning-bold`]: 'brand.warning.200',
        [`danger-subtle`]: 'brand.danger.600',
        [`danger-bold`]: 'brand.danger.200',
        [`disabled`]: 'brand.neutral.900',
      },
      [`brand-subtle`]: 'brand.primary.700',
      [`brand-bold`]: 'brand.primary.200',
      [`brand-medium`]: 'brand.primary.400',
      [`primary-inverse`]: 'white.100',
      [`elevation-1`]: 'black.100',
      [`elevation-2`]: 'brand.neutral.1000',
      [`elevation-3`]: 'brand.neutral.900',
      [`elevation-glass-1`]: 'black.50',
      [`elevation-glass-2`]: 'black.80',
      [`brand-verysubtle`]: 'brand.primary.1000',
      [`brand-extra-bold`]: 'brand.primary.100',
      [`overlay`]: 'white.70',
    },
    [`stroke`]: {
      [`primary`]: 'brand.neutral.900',
      [`secondary`]: 'brand.neutral.800',
      [`tertiary`]: 'brand.neutral.700',
      [`state`]: {
        [`success-subtle`]: 'brand.success.500',
        [`success-bold`]: 'brand.success.300',
        [`warning-subtle`]: 'brand.warning.500',
        [`warning-bold`]: 'brand.warning.300',
        [`danger-subtle`]: 'brand.danger.500',
        [`danger-bold`]: 'brand.danger.300',
        [`hover`]: 'brand.primary.800',
        [`focused`]: 'brand.primary.500',
        [`pressed`]: 'brand.primary.300',
        [`disabled`]: 'brand.neutral.800',
      },
      [`brand-subtle`]: 'brand.primary.600',
      [`brand-medium`]: 'brand.primary.400',
      [`brand-bold`]: 'brand.primary.300',
    },
    [`icon`]: {
      [`primary`]: 'white.100',
      [`secondary`]: 'brand.neutral.500',
      [`tertiary`]: 'brand.neutral.700',
      [`state`]: {
        [`success-bold`]: 'brand.success.200',
        [`success-subtle`]: 'brand.success.600',
        [`warning-bold`]: 'brand.warning.200',
        [`warning-subtle`]: 'brand.warning.600',
        [`danger-bold`]: 'brand.danger.200',
        [`danger-subtle`]: 'brand.danger.600',
        [`disabled`]: 'brand.neutral.800',
      },
      [`brand-bold`]: 'brand.primary.300',
      [`brand-medium`]: 'brand.primary.500',
      [`brand-subtle`]: 'brand.primary.800',
      [`primiary-inverse`]: 'black.100',
      [`secondary-inverse`]: 'brand.neutral.800',
      [`tertiary-inverse`]: 'brand.neutral.600',
      [`on-light-background`]: 'black.100',
      [`on-dark-background`]: 'white.100',
      [`border`]: 'stroke.primary',
      [`primary-inverse`]: 'black.100',
      [`bg-fill`]: 'obsidian.900',
    },
    [`illustrations`]: {
      [`shade-1`]: 'grey.800',
      [`shade-2`]: 'grey.600',
      [`shade-3`]: 'grey.300',
      [`shade-4`]: 'grey.100',
    },
    [`tabs`]: {
      [`background`]: 'background.secondary',
      [`stroke`]: 'stroke.primary',
    },
    [`charts`]: {
      [`success`]: 'blue-spark.600',
      [`warning`]: {
        [`1`]: 'golden-stone.200',
        [`2`]: 'golden-stone.300',
        [`3`]: 'golden-stone.400',
        [`4`]: 'golden-stone.600',
      },
      [`deny`]: {
        [`1`]: 'electric-crimson.200',
        [`2`]: 'electric-crimson.400',
        [`3`]: 'electric-crimson.500',
        [`4`]: 'electric-crimson.700',
        [`graph-default`]: 'electric-crimson.600',
        [`graph-hover`]: 'electric-crimson.500',
      },
      [`awaiting`]: 'obsidian.300',
      [`approve`]: {
        [`1`]: 'green-bell-pepper.200',
        [`2`]: 'green-bell-pepper.300',
        [`3`]: 'green-bell-pepper.400',
        [`4`]: 'green-bell-pepper.600',
        [`graph-default`]: 'green-bell-pepper.300',
        [`graph-hover`]: 'green-bell-pepper.200',
      },
      [`change`]: {
        [`1`]: 'golden-stone.200',
        [`2`]: 'golden-stone.300',
        [`3`]: 'golden-stone.400',
        [`4`]: 'golden-stone.600',
        [`graph-default`]: 'golden-stone.300',
        [`graph-hover`]: 'golden-stone.200',
      },
      [`failed`]: 'charts.deny.graph-default',
      [`track-color`]: 'obsidian.900',
      [`in-progress`]: 'electric-indigo.600',
    },
  },
};

export type SemanticTheme = typeof semantic;

export const semanticWithCSS = {
  [`colors`]: {
    [`text`]: {
      [`primary`]: 'white.100',
      [`secondary`]: 'brand.neutral.400',
      [`tertiary`]: 'brand.neutral.600',
      [`brand-bold`]: 'brand.primary.200',
      [`state`]: {
        [`success-bold`]: 'brand.success.100',
        [`success-subtle`]: 'brand.success.700',
        [`warning-bold`]: 'brand.warning.100',
        [`warning-subtle`]: 'brand.warning.700',
        [`danger-bold`]: 'brand.danger.100',
        [`danger-subtle`]: 'brand.danger.700',
        [`disabled`]: 'brand.neutral.700',
        [`warning-bold-hover`]: 'brand.warning.200',
      },
      [`brand-subtle`]: 'brand.primary.900',
      [`brand-medium`]: 'brand.primary.400',
      [`primary-inverse`]: 'black.100',
      [`secondary-inverse`]: 'brand.neutral.700',
      [`tertiary-inverse`]: 'brand.neutral.500',
      [`on-dark-background`]: 'white.100',
      [`on-light-background`]: 'black.100',
    },
    [`background`]: {
      [`primary`]: 'black.100',
      [`secondary`]: 'brand.neutral.1000',
      [`tertiary`]: 'brand.neutral.800',
      [`state`]: {
        [`success-subtle`]: 'brand.success.500',
        [`success-bold`]: 'brand.success.200',
        [`warning-subtle`]: 'brand.warning.500',
        [`warning-bold`]: 'brand.warning.200',
        [`danger-subtle`]: 'brand.danger.600',
        [`danger-bold`]: 'brand.danger.200',
        [`disabled`]: 'brand.neutral.900',
      },
      [`brand-subtle`]: 'brand.primary.700',
      [`brand-bold`]: 'brand.primary.200',
      [`brand-medium`]: 'brand.primary.400',
      [`primary-inverse`]: 'white.100',
      [`elevation-1`]: 'black.100',
      [`elevation-2`]: 'brand.neutral.1000',
      [`elevation-3`]: 'brand.neutral.900',
      [`elevation-glass-1`]: 'black.50',
      [`elevation-glass-2`]: 'black.80',
      [`brand-verysubtle`]: 'brand.primary.1000',
      [`brand-extra-bold`]: 'brand.primary.100',
      [`overlay`]: 'white.70',
    },
    [`stroke`]: {
      [`primary`]: 'brand.neutral.900',
      [`secondary`]: 'brand.neutral.800',
      [`tertiary`]: 'brand.neutral.700',
      [`state`]: {
        [`success-subtle`]: 'brand.success.500',
        [`success-bold`]: 'brand.success.300',
        [`warning-subtle`]: 'brand.warning.500',
        [`warning-bold`]: 'brand.warning.300',
        [`danger-subtle`]: 'brand.danger.500',
        [`danger-bold`]: 'brand.danger.300',
        [`hover`]: 'brand.primary.800',
        [`focused`]: 'brand.primary.500',
        [`pressed`]: 'brand.primary.300',
        [`disabled`]: 'brand.neutral.800',
      },
      [`brand-subtle`]: 'brand.primary.600',
      [`brand-medium`]: 'brand.primary.400',
      [`brand-bold`]: 'brand.primary.300',
    },
    [`icon`]: {
      [`primary`]: 'white.100',
      [`secondary`]: 'brand.neutral.500',
      [`tertiary`]: 'brand.neutral.700',
      [`state`]: {
        [`success-bold`]: 'brand.success.200',
        [`success-subtle`]: 'brand.success.600',
        [`warning-bold`]: 'brand.warning.200',
        [`warning-subtle`]: 'brand.warning.600',
        [`danger-bold`]: 'brand.danger.200',
        [`danger-subtle`]: 'brand.danger.600',
        [`disabled`]: 'brand.neutral.800',
      },
      [`brand-bold`]: 'brand.primary.300',
      [`brand-medium`]: 'brand.primary.500',
      [`brand-subtle`]: 'brand.primary.800',
      [`primiary-inverse`]: 'black.100',
      [`secondary-inverse`]: 'brand.neutral.800',
      [`tertiary-inverse`]: 'brand.neutral.600',
      [`on-light-background`]: 'black.100',
      [`on-dark-background`]: 'white.100',
      [`border`]: 'stroke.primary',
      [`primary-inverse`]: 'black.100',
      [`bg-fill`]: 'obsidian.900',
    },
    [`illustrations`]: {
      [`shade-1`]: 'grey.800',
      [`shade-2`]: 'grey.600',
      [`shade-3`]: 'grey.300',
      [`shade-4`]: 'grey.100',
    },
    [`tabs`]: {
      [`background`]: 'background.secondary',
      [`stroke`]: 'stroke.primary',
    },
    [`charts`]: {
      [`success`]: 'blue-spark.600',
      [`warning`]: {
        [`1`]: 'golden-stone.200',
        [`2`]: 'golden-stone.300',
        [`3`]: 'golden-stone.400',
        [`4`]: 'golden-stone.600',
      },
      [`deny`]: {
        [`1`]: 'electric-crimson.200',
        [`2`]: 'electric-crimson.400',
        [`3`]: 'electric-crimson.500',
        [`4`]: 'electric-crimson.700',
        [`graph-default`]: 'electric-crimson.600',
        [`graph-hover`]: 'electric-crimson.500',
      },
      [`awaiting`]: 'obsidian.300',
      [`approve`]: {
        [`1`]: 'green-bell-pepper.200',
        [`2`]: 'green-bell-pepper.300',
        [`3`]: 'green-bell-pepper.400',
        [`4`]: 'green-bell-pepper.600',
        [`graph-default`]: 'green-bell-pepper.300',
        [`graph-hover`]: 'green-bell-pepper.200',
      },
      [`change`]: {
        [`1`]: 'golden-stone.200',
        [`2`]: 'golden-stone.300',
        [`3`]: 'golden-stone.400',
        [`4`]: 'golden-stone.600',
        [`graph-default`]: 'golden-stone.300',
        [`graph-hover`]: 'golden-stone.200',
      },
      [`failed`]: 'charts.deny.graph-default',
      [`track-color`]: 'obsidian.900',
      [`in-progress`]: 'electric-indigo.600',
    },
  },
};

export type SemanticwithcssTheme = typeof semanticWithCSS;

export const components = {
  [`colors`]: {
    [`components`]: {
      [`buttons`]: {
        [`primary`]: {
          [`background-default`]: 'brand.primary.600',
          [`background-hover`]: 'brand.primary.500',
          [`background-pressed`]: 'brand.primary.700',
          [`background-focus`]: 'brand.primary.600',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'text.primary',
          [`icon-default`]: 'white.100',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-focus`]: 'brand.primary.500',
          [`text-disabled`]: 'text.state.disabled',
        },
        [`secondary`]: {
          [`background-default`]: 'brand.neutral.800',
          [`background-hover`]: 'brand.neutral.700',
          [`background-pressed`]: 'brand.neutral.1000',
          [`background-focus`]: 'brand.neutral.800',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'white.100',
          [`text-disabled`]: 'text.state.disabled',
          [`icon-default`]: 'white.100',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-focus`]: 'brand.neutral.500',
        },
        [`danger`]: {
          [`background-default`]: 'brand.danger.500',
          [`background-hover`]: 'brand.danger.400',
          [`background-pressed`]: 'brand.danger.700',
          [`background-focus`]: 'brand.danger.400',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'white.100',
          [`text-disabled`]: 'text.state.disabled',
          [`icon-default`]: 'white.70',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-focus`]: 'brand.danger.500',
        },
        [`danger-secondary`]: {
          [`background-default`]: 'brand.danger.800',
          [`background-hover`]: 'brand.danger.700',
          [`background-pressed`]: 'brand.danger.1000',
          [`background-focus`]: 'brand.danger.700',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'white.100',
          [`text-disabled`]: 'text.state.disabled',
          [`icon-default`]: 'white.70',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-focus`]: 'brand.danger.500',
        },
        [`outline`]: {
          [`background-default`]: 'background.primary',
          [`background-hover`]: 'background.brand-verysubtle',
          [`background-pressed`]: 'background.brand-subtle',
          [`background-focus`]: 'components.buttons.icon-button.background-focus',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'text.secondary',
          [`text-disabled`]: 'text.state.disabled',
          [`icon-default`]: 'white.100',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-focus`]: 'brand.neutral.500',
          [`stroke-default`]: 'stroke.primary',
          [`stroke-hover`]: 'stroke.brand-subtle',
          [`stroke-pressed`]: 'components.buttons.primary.background-pressed',
          [`text-hover`]: 'text.brand-bold',
          [`text-pressed`]: 'text.brand-bold',
        },
        [`icon-button`]: {
          [`background-hover`]: 'white.0',
          [`background-pressed`]: 'brand.primary.900',
          [`background-focus`]: 'white.0',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'text.primary-inverse',
          [`text-disabled`]: 'text.state.disabled',
          [`icon-default`]: 'components.buttons.secondary.icon-default',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-focus`]: 'components.nav.stroke',
          [`icon-hover`]: 'brand.primary.400',
        },
        [`tertiary`]: {
          [`background-default`]: 'background.brand-verysubtle',
          [`background-hover`]: 'brand.primary.900',
          [`background-pressed`]: 'blue-spark.800',
          [`background-focus`]: 'components.buttons.tertiary.background-default',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'text.brand-bold',
          [`text-disabled`]: 'text.state.disabled',
          [`icon-default`]: 'icon.brand-bold',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-focus`]: 'components.buttons.primary.stroke-focus',
          [`stroke-default`]: 'white.0',
          [`stroke-hover`]: 'white.0',
          [`stroke-pressed`]: 'white.0',
        },
        [`button-link`]: {
          [`default`]: {
            [`text-default`]: 'text.primary',
            [`text-disabled`]: 'text.state.disabled',
            [`icon-default`]: 'white.100',
            [`icon-disabled`]: 'icon.state.disabled',
            [`text-hover`]: 'components.buttons.primary.background-default',
            [`text-pressed`]: 'components.buttons.primary.background-pressed',
            [`text-focused`]: 'components.buttons.primary.background-focus',
          },
          [`danger`]: {
            [`text-default`]: 'components.buttons.danger.background-default',
            [`text-disabled`]: 'text.state.disabled',
            [`icon-disabled`]: 'icon.state.disabled',
            [`text-pressed`]: 'components.buttons.danger.background-pressed',
            [`text-hover`]: 'components.buttons.danger.background-hover',
            [`text-focused`]: 'components.buttons.danger.background-default',
          },
          [`warning`]: {
            [`text-default`]: 'text.state.warning-bold',
            [`text-disabled`]: 'text.state.disabled',
            [`icon-default`]: 'white.100',
            [`icon-disabled`]: 'icon.state.disabled',
            [`text-hover`]: 'golden-stone.200',
            [`text-pressed`]: 'golden-stone.300',
            [`text-focused`]: 'components.buttons.button-link.warning.text-default',
          },
        },
        [`subtle`]: {
          [`background-default`]: 'white.0',
          [`background-hover`]: 'background.brand-verysubtle',
          [`background-pressed`]: 'background.brand-subtle',
          [`background-focus`]: 'components.buttons.icon-button.background-focus',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'text.secondary',
          [`text-disabled`]: 'text.state.disabled',
          [`icon-default`]: 'white.100',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-focus`]: 'brand.neutral.500',
          [`text-hover`]: 'text.brand-bold',
          [`text-pressed`]: 'text.brand-bold',
          [`stroke-default`]: 'white.0',
          [`stroke-hover`]: 'stroke.brand-subtle',
        },
      },
      [`toggles`]: {
        [`background-selected`]: 'brand.primary.600',
        [`background-hover`]: 'brand.primary.500',
        [`background-focus`]: 'brand.primary.600',
        [`background-disabled`]: 'background.state.disabled',
        [`icon-default`]: 'white.100',
        [`icon-disabled`]: 'icon.state.disabled',
        [`stroke-focus`]: 'brand.primary.500',
        [`background-unselected`]: 'brand.neutral.800',
        [`stroke-default`]: 'stroke.tertiary',
      },
      [`rating`]: {
        [`star`]: 'golden-stone.300',
        [`heart`]: 'electric-crimson.500',
        [`empty`]: 'icon.tertiary',
        [`disabled`]: 'icon.state.disabled',
        [`filled`]: 'golden-stone.300',
      },
      [`form-control`]: {
        [`background-default`]: 'brand.neutral.800',
        [`background-hover`]: 'brand.neutral.600',
        [`background-pressed`]: 'brand.neutral.800',
        [`background-focus`]: 'brand.neutral.800',
        [`background-disabled`]: 'background.state.disabled',
        [`text-default`]: 'text.primary',
        [`text-disabled`]: 'brand.neutral.800',
        [`icon-default`]: 'icon.secondary',
        [`icon-disabled`]: 'icon.state.disabled',
        [`stroke-focus`]: 'brand.primary.500',
        [`stroke-default`]: 'stroke.secondary',
        [`stroke-disabled`]: 'brand.neutral.900',
        [`stroke-pressed`]: 'stroke.tertiary',
        [`text-placeholder`]: 'brand.neutral.600',
        [`text-secondary`]: 'brand.neutral.500',
        [`stroke-hover`]: 'stroke.tertiary',
        [`stroke-error`]: 'stroke.state.danger-subtle',
        [`text-error`]: 'text.state.danger-bold',
        [`icon-error`]: 'icon.state.danger-bold',
      },
      [`rows`]: {
        [`background-default`]: 'brand.neutral.800',
        [`background-hover`]: 'background.elevation-glass-2',
        [`background-pressed`]: 'brand.neutral.800',
        [`background-focus`]: 'brand.neutral.800',
        [`background-disabled`]: 'background.state.disabled',
        [`text-default`]: 'text.primary',
        [`text-placeholder`]: 'brand.neutral.600',
        [`text-secondary`]: 'brand.neutral.500',
        [`text-disabled`]: 'brand.neutral.800',
        [`icon-default`]: 'icon.secondary',
        [`icon-disabled`]: 'icon.state.disabled',
        [`stroke-default`]: 'stroke.tertiary',
        [`stroke-focus`]: 'brand.primary.500',
        [`stroke-pressed`]: 'stroke.tertiary',
        [`stroke-disabled`]: 'brand.neutral.900',
        [`cell-hover`]: 'white.5',
      },
      [`tags`]: {
        [`complete`]: {
          [`background-default`]: 'background.brand-subtle',
          [`text-default`]: 'text.primary',
          [`icon-default`]: 'icon.brand-bold',
          [`icon-secondary`]: 'brand.primary.600',
        },
        [`incomplete`]: {
          [`background-default`]: 'background.state.danger-subtle',
          [`icon-default`]: 'icon.state.danger-bold',
          [`text-default`]: 'text.primary',
          [`icon-secondary`]: 'electric-crimson.600',
        },
        [`progress`]: {
          [`background-default`]: 'electric-indigo.600',
          [`icon-default`]: 'electric-indigo.100',
          [`text-default`]: 'text.primary',
          [`icon-secondary`]: 'electric-indigo.600',
          [`icon-tertiary`]: 'electric-indigo.900',
        },
        [`active`]: {
          [`background-default`]: 'background.state.success-subtle',
          [`icon-default`]: 'icon.state.success-bold',
          [`text-default`]: 'text.primary',
        },
        [`initiatied`]: {
          [`background-default`]: 'background.secondary',
          [`text-default`]: 'text.primary',
          [`icon-default`]: 'icon.secondary',
        },
        [`secondary-stroke`]: 'stroke.primary',
        [`secondary-bg`]: 'background.elevation-1',
      },
      [`chips`]: {
        [`background-default`]: 'background.primary',
        [`background-hover`]: 'background.primary',
        [`background-pressed`]: 'background.secondary',
        [`background-focus`]: 'white.50',
        [`background-disabled`]: 'background.state.disabled',
        [`text-default`]: 'text.primary',
        [`text-disabled`]: 'text.state.disabled',
        [`icon-default`]: 'white.70',
        [`icon-disabled`]: 'icon.state.disabled',
        [`stroke-hover`]: 'stroke.primary',
      },
      [`nav`]: {
        [`background-selected`]: 'brand.primary.900',
        [`text-default`]: 'text.secondary',
        [`text-active`]: 'text.brand-bold',
        [`text-selected-2ndlevel`]: 'text.primary',
        [`icon-default`]: 'icon.secondary',
        [`background-hover`]: 'background.secondary',
        [`icon-active`]: 'icon.brand-bold',
        [`stroke`]: 'stroke.primary',
        [`background-pressed`]: 'components.table-row.background-pressed',
        [`background`]: 'background.primary',
        [`collapse-button-radius`]: 'space-100',
      },
      [`button-link`]: {
        [`text-default`]: 'text.primary',
        [`text-disabled`]: 'text.state.disabled',
        [`icon-default`]: 'white.100',
        [`icon-disabled`]: 'icon.state.disabled',
        [`text-hover`]: 'components.buttons.primary.background-default',
        [`text-pressed`]: 'components.buttons.primary.background-pressed',
        [`text-focused`]: 'components.buttons.primary.background-focus',
      },
      [`pagination`]: {
        [`background-default`]: 'white.0',
        [`background-hover`]: 'white.0',
        [`background-pressed`]: 'components.buttons.icon-button.background-pressed',
        [`background-focus`]: 'components.buttons.icon-button.background-focus',
        [`background-disabled`]: 'background.state.disabled',
        [`text-default`]: 'white.100',
        [`text-disabled`]: 'text.state.disabled',
        [`icon-default`]: 'white.100',
        [`text-hover`]: 'text.brand-bold',
        [`text-pressed`]: 'text.brand-bold',
        [`icon-disabled`]: 'icon.state.disabled',
        [`stroke-focus`]: 'brand.neutral.500',
        [`background-active`]: 'background.secondary',
        [`text-active`]: 'text.brand-bold',
      },
      [`filters`]: {
        [`default`]: {
          [`background-default`]: 'background.secondary',
          [`background-hover`]: 'background.elevation-3',
          [`background-pressed`]: 'background.secondary',
          [`background-focus`]: 'background.primary',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'text.secondary',
          [`text-disabled`]: 'text.state.disabled',
          [`icon-default`]: 'icon.secondary',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-default`]: 'stroke.primary',
          [`text-emphasized`]: 'text.brand-bold',
          [`stroke-focus`]: 'stroke.primary',
        },
        [`emphasized`]: {
          [`background-default`]: 'background.brand-bold',
          [`background-hover`]: 'background.brand-medium',
          [`background-pressed`]: 'background.brand-extra-bold',
          [`background-focus`]: 'components.filters.emphasized.background-default',
          [`background-disabled`]: 'background.state.disabled',
          [`text-default`]: 'text.primary-inverse',
          [`text-emphasized`]: 'text.primary-inverse',
          [`text-disabled`]: 'text.state.disabled',
          [`icon-default`]: 'icon.primary-inverse',
          [`icon-disabled`]: 'icon.state.disabled',
          [`stroke-default`]: 'blue-spark.300',
          [`stroke-focus`]: 'stroke.brand-subtle',
          [`stroke-disabled`]: 'stroke.state.disabled',
          [`stroke-pressed`]: 'blue-spark.300',
          [`stroke-hover`]: 'blue-spark.500',
        },
      },
      [`dropdown`]: {
        [`background-default`]: 'background.primary',
        [`background-hover`]: 'brand.neutral.800',
        [`background-disabled`]: 'background.state.disabled',
        [`text-default`]: 'text.primary',
        [`text-secondary`]: 'brand.neutral.500',
        [`text-disabled`]: 'brand.neutral.800',
        [`icon-default`]: 'icon.secondary',
        [`icon-disabled`]: 'icon.state.disabled',
        [`stroke-default`]: 'stroke.tertiary',
        [`stroke-disabled`]: 'brand.neutral.900',
        [`background-selected`]: 'background.brand-verysubtle',
      },
      [`radio-button-group`]: {
        [`background-default`]: 'background.primary',
        [`background-hover`]: 'background.secondary',
        [`background-pressed`]: 'brand.primary.700',
        [`background-focus`]: 'brand.primary.600',
        [`background-disabled`]: 'background.state.disabled',
        [`text-default`]: 'text.secondary',
        [`text-disabled`]: 'text.state.disabled',
        [`icon-default`]: 'icon.secondary',
        [`icon-disabled`]: 'icon.state.disabled',
        [`stroke-default`]: 'stroke.primary',
        [`stroke-focus`]: 'stroke.tertiary',
      },
      [`table-row`]: {
        [`background-default`]: 'brand.neutral.800',
        [`background-hover`]: 'background.elevation-glass-2',
        [`background-pressed`]: 'brand.neutral.800',
        [`background-focus`]: 'brand.neutral.800',
        [`background-disabled`]: 'background.state.disabled',
        [`text-default`]: 'text.primary',
        [`text-placeholder`]: 'brand.neutral.600',
        [`text-secondary`]: 'brand.neutral.500',
        [`text-disabled`]: 'brand.neutral.800',
        [`icon-default`]: 'icon.secondary',
        [`icon-disabled`]: 'icon.state.disabled',
        [`stroke-default`]: 'stroke.tertiary',
        [`stroke-focus`]: 'brand.primary.500',
        [`stroke-pressed`]: 'stroke.tertiary',
        [`stroke-disabled`]: 'brand.neutral.900',
        [`cell-hover`]: 'white.5',
      },
      [`alerts`]: {
        [`info`]: {
          [`background-default`]: 'background.primary-inverse',
          [`text-default`]: 'text.primary-inverse',
          [`icon-default`]: 'icon.primary-inverse',
        },
        [`success`]: {
          [`background-default`]: 'background.state.success-subtle',
          [`text-default`]: 'text.state.success-bold',
          [`icon-default`]: 'icon.state.success-bold',
        },
        [`warning`]: {
          [`background-default`]: 'background.state.warning-subtle',
          [`text-default`]: 'text.state.warning-bold',
          [`icon-default`]: 'icon.state.warning-bold',
        },
        [`error`]: {
          [`background-default`]: 'background.state.danger-subtle',
          [`text-default`]: 'text.state.danger-bold',
          [`icon-default`]: 'icon.state.danger-bold',
        },
      },
      [`context-menu`]: {
        [`background-default`]: 'background.primary',
        [`background-hover`]: 'deep-sea.800',
        [`background-disabled`]: 'background.state.disabled',
        [`text-default`]: 'text.primary',
        [`text-secondary`]: 'brand.neutral.500',
        [`text-disabled`]: 'brand.neutral.800',
        [`icon-default`]: 'icon.secondary',
        [`icon-disabled`]: 'icon.state.disabled',
        [`stroke-default`]: 'stroke.tertiary',
        [`stroke-disabled`]: 'brand.neutral.900',
        [`background-selected`]: 'background.brand-verysubtle',
        [`background-pressed`]: 'deep-sea.800',
      },
    },
  },
};

export type ComponentsTheme = typeof components;

export const prefix = 'linx';

export const basePxFontSize = 16;
